let menuAnchor = document.querySelectorAll('.js-menuAnchor li a')
let contentAnchor = document.querySelectorAll('.js-contentAnchor')

if (menuAnchor && contentAnchor) {

  const options = { rootMargin: '-40% 0px -40%', threshold: 0 }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const id = entry.target.id
      if (entry.intersectionRatio > 0) {
        menuAnchor.forEach(link => link.classList.remove("active"))
        document.querySelector(`.js-menuAnchor li a[href="#${id}"]`).classList.add('active')
      }
    })
  }, options)

  contentAnchor.forEach((content) => {
    observer.observe(content);
  })

}
